// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__cQwkl","icon":"LogoutButton_icon__Uiksf"};